import styled from 'styled-components';
import { CpBody02Primary } from 'components/atoms/customer-portal/typography';

export const BackWrapper = styled.div`
  padding-left: var(--cp-spacing-05);
  padding-right: var(--cp-spacing-05);
  padding-top: var(--cp-spacing-04);
  padding-bottom: var(--cp-spacing-04);
  display: flex;
  align-items: center;
  justify-content: start;
  ${CpBody02Primary} {
    margin-bottom: 0;
  }
`;

export const BackIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--cp-spacing-03);
  padding: var(--cp-spacing-03);
  cursor: pointer;
  .cp-dark-background & svg {
    fill: var(--cp-white);
  }
`;
